import React from 'react';
import styled from 'styled-components';

import mutedImg from '../../../assets/images/VolumeOff2.svg';
import unmutedImg from '../../../assets/images/VolumeOn2.svg';

const HeaderSoundWrapper = styled.div`
    position: absolute;
    right: 8vw;
    bottom: 7%;
    width: 3rem;
    height: 3rem;
`;

const HeaderSoundIcon = styled.img`
    height: 100%;
    width: auto;
`;

const HeaderSound = ({mutedState, clicked}) => {
    return (
    <HeaderSoundWrapper onClick={clicked}>
        <HeaderSoundIcon src={mutedState ? mutedImg : unmutedImg}/>
    </HeaderSoundWrapper>
    )
};

export default HeaderSound